// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1KOL9","header":"ClearentDisclaimer_header__2nl6F","inner":"ClearentDisclaimer_inner__1cUAr"};